const showMoreButtons = document.querySelectorAll('.js--show_more');
const sets = document.querySelectorAll('.js--sets__item');



function updateMaxHeight(prosList, btn) {
  const mobileMaxHeight = 112;
  const desktopMaxHeight = 350;

  const isMobile = window.matchMedia('(max-width: 1280px)').matches;
  const maxHeight = isMobile ? mobileMaxHeight : desktopMaxHeight;

  if (prosList && prosList.offsetHeight <= maxHeight && btn) {
    btn.style.display = 'none';
  } else if (!prosList) {
    btn.style.display = 'none';
  } else {
    btn.style.display = 'flex';
  }
}


function getColumnsCount() {
  const screenWidth = window.innerWidth;
  if (screenWidth >= 1200) {
    return 3;
  } else {
    return 1;
  }
}

function openRowSets(clickedButton) {
  const wrapper = clickedButton.closest('.js--sets_wrapper');
  const allItems = wrapper.querySelectorAll('.js--sets__item');
  const columnsCount = getColumnsCount();
  let clickedIndex = Array.from(allItems).indexOf(clickedButton.closest('.js--sets__item'));

  const startIndex = Math.floor(clickedIndex / columnsCount) * columnsCount;
  const endIndex = startIndex + columnsCount;

  for (let i = startIndex; i < endIndex && i < allItems.length; i++) {
    const item = allItems[i];
    const prosList = item.querySelector('.js--pros_list');
    const button = item.querySelector('.js--show_more');

    if (prosList) {
      prosList.classList.toggle('show');
    }
    if (button) {
      button.classList.toggle('less');
      if (button.classList.contains('less')) {
        button.textContent = button.getAttribute('data-less-text');
      } else {
        button.textContent = button.getAttribute('data-more-text');
      }
    }
  }
}

showMoreButtons.forEach((btn) => {
  btn.addEventListener('click', function (e) {
    if (window.innerWidth >= 1200) {
      openRowSets(this);
    } else {
      const targetEl = this.parentElement.previousElementSibling;
      if (targetEl && targetEl.classList.contains('js--pros_list')) {
        targetEl.classList.toggle('show');
      }
      this.classList.toggle('less');
      if (this.classList.contains('less')) {
        this.textContent = this.getAttribute('data-less-text');
      } else {
        this.textContent = this.getAttribute('data-more-text');
      }
    }
  });
});


document.addEventListener('DOMContentLoaded', () => {
  sets.forEach(item => {
    item.style.setProperty('--top-header-color', item.getAttribute('data-color'));
    const prosList = item.querySelector('.js--pros_list ul');
    const btn = item.querySelector('.js--show_more');

    updateMaxHeight(prosList, btn);
  });
});

window.addEventListener('resize', () => {
  sets.forEach(item => {
    const prosList = item.querySelector('.js--pros_list ul');
    const btn = item.querySelector('.js--show_more');

    updateMaxHeight(prosList, btn);
  });
});

